import type { ApiSearchQuery } from "@/lib/api/api-type-helper";
import { createTabFilterVisibilityState } from "@/lib/listPage";
import type { EnumObjectToUnion } from "@/utils/enum";

import type { AppsPeopleTableRow } from "./-types";

type QUERY = ApiSearchQuery<"/v2/app-people/count", "get">;

type CATEGORY = Exclude<QUERY, undefined>["category"];
type CATEGORY_FILTER = Extract<
  CATEGORY,
  "ALL_ACTIVE" | "ALL_JOINING" | "ALL_LEAVING" | "ALL_ALL"
>;

export const TAB_FILTER: { [key in string]: CATEGORY_FILTER } = {
  JOINED: "ALL_ACTIVE",
  JOINING: "ALL_JOINING",
  LEAVING: "ALL_LEAVING",
  ALL: "ALL_ALL",
} as const;

export type TabFilter = EnumObjectToUnion<typeof TAB_FILTER>;

type ORDER_BY = Exclude<QUERY, undefined>["orderBy"];
export type ORDER_BY_FILTER = Extract<ORDER_BY, "PERSON_NAME" | "PLACE">;

export const SortColumns = [
  "PERSON_NAME",
  "PLACE",
] as const satisfies ORDER_BY_FILTER[];

export type SORTABLE_COLUMNS = Extract<
  keyof AppsPeopleTableRow,
  "person" | "place"
>;

export const ColumnsToSortColumns = {
  person: "PERSON_NAME",
  place: "PLACE",
} as const satisfies Record<SORTABLE_COLUMNS, ORDER_BY_FILTER>;

export const SortColumnsToColumns = {
  PERSON_NAME: "person",
  PLACE: "place",
} as const satisfies Record<ORDER_BY_FILTER, SORTABLE_COLUMNS>;

export const tabFilterVisibilityStates = createTabFilterVisibilityState({
  columns: [
    "person",
    "apps",
    "place",
    "departments",
    "joinedOn",
    "leftOn",
    "actions",
  ] satisfies (keyof AppsPeopleTableRow | "actions")[],
  permanentColumns: [
    "person",
    "apps",
    "place",
    "departments",
    "joinedOn",
    "leftOn",
    "actions",
  ],
  tabFilterToColumns: {
    [TAB_FILTER.JOINED]: [],
    [TAB_FILTER.JOINING]: [],
    [TAB_FILTER.LEAVING]: [],
    [TAB_FILTER.ALL]: [],
  },
});

export { Columns, type Columns as ColumnsType } from "./-enums/columns";
